import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Plus, Eye, Edit, CheckCircle, Clock, ArrowLeft, Download, Search } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
export function CommitteePolicies() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const policies = [{
    id: 1,
    title: 'Kebijakan Pembentukan Chapter Baru',
    status: 'Menunggu',
    date: '2 hari lalu',
    submittedBy: 'Made Suryawan',
    category: 'Chapter',
    version: 'v1.0'
  }, {
    id: 2,
    title: 'Pedoman Peningkatan Anggaran Q1 2025',
    status: 'Menunggu',
    date: '3 hari lalu',
    submittedBy: 'Dewi Lestari',
    category: 'Keuangan',
    version: 'v1.0'
  }, {
    id: 3,
    title: 'Panduan Perjanjian Kemitraan',
    status: 'Disetujui',
    date: '1 minggu lalu',
    submittedBy: 'Ahmad Wijaya',
    category: 'Kemitraan',
    version: 'v2.1'
  }, {
    id: 4,
    title: 'Kebijakan Sponsorship Acara',
    status: 'Disetujui',
    date: '2 minggu lalu',
    submittedBy: 'Siti Nurhaliza',
    category: 'Acara',
    version: 'v1.5'
  }, {
    id: 5,
    title: 'Standar Operasional Prosedur Chapter',
    status: 'Disetujui',
    date: '3 minggu lalu',
    submittedBy: 'Budi Santoso',
    category: 'Chapter',
    version: 'v3.0'
  }];
  const filteredPolicies = policies.filter(policy => policy.title.toLowerCase().includes(searchQuery.toLowerCase()) || policy.submittedBy.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleApprove = (id: number) => {
    if (confirm('Apakah Anda yakin ingin menyetujui kebijakan ini?')) {
      alert(`Kebijakan #${id} telah disetujui dan dipublikasikan`);
    }
  };
  const handleReview = (id: number) => {
    navigate(`/committee/policies/${id}`);
  };
  return <div className="min-h-screen bg-white" data-id="element-1940">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1941">
        {/* Header */}
        <div className="mb-8" data-id="element-1942">
          <Button variant="ghost" onClick={() => navigate('/committee/dashboard')} className="mb-4" data-id="element-1943">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1944" />
            Kembali ke Dasbor
          </Button>
          <div className="flex items-center justify-between" data-id="element-1945">
            <div data-id="element-1946">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1947">
                Manajemen Kebijakan
              </h1>
              <p className="text-neutral-600" data-id="element-1948">
                Review dan setujui kebijakan organisasi
              </p>
            </div>
            <Button onClick={() => navigate('/committee/policies/create')} data-id="element-1949">
              <Plus className="w-4 h-4 mr-2" data-id="element-1950" />
              Kebijakan Baru
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-1951">
          <Card data-id="element-1952">
            <CardContent className="p-6" data-id="element-1953">
              <div className="flex items-center gap-4" data-id="element-1954">
                <div className="p-3 rounded-lg bg-warning-light" data-id="element-1955">
                  <Clock className="w-6 h-6 text-warning" data-id="element-1956" />
                </div>
                <div data-id="element-1957">
                  <h3 className="text-2xl font-semibold text-neutral-900" data-id="element-1958">
                    {policies.filter(p => p.status === 'Menunggu').length}
                  </h3>
                  <p className="text-sm text-neutral-600" data-id="element-1959">
                    Menunggu Persetujuan
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-1960">
            <CardContent className="p-6" data-id="element-1961">
              <div className="flex items-center gap-4" data-id="element-1962">
                <div className="p-3 rounded-lg bg-success-light" data-id="element-1963">
                  <CheckCircle className="w-6 h-6 text-success" data-id="element-1964" />
                </div>
                <div data-id="element-1965">
                  <h3 className="text-2xl font-semibold text-neutral-900" data-id="element-1966">
                    {policies.filter(p => p.status === 'Disetujui').length}
                  </h3>
                  <p className="text-sm text-neutral-600" data-id="element-1967">
                    Disetujui Bulan Ini
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Search */}
        <div className="mb-6" data-id="element-1968">
          <div className="relative" data-id="element-1969">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-1970" />
            <Input placeholder="Cari kebijakan..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10" data-id="element-1971" />
          </div>
        </div>

        {/* Policies List */}
        <Card data-id="element-1972">
          <CardHeader data-id="element-1973">
            <CardTitle data-id="element-1974">Daftar Kebijakan</CardTitle>
          </CardHeader>
          <CardContent data-id="element-1975">
            <div className="space-y-4" data-id="element-1976">
              {filteredPolicies.map(policy => <div key={policy.id} className="p-4 border border-neutral-200 rounded-lg hover:border-atios-primary transition-colors" data-id="element-1977">
                  <div className="flex items-start justify-between mb-2" data-id="element-1978">
                    <div className="flex-1" data-id="element-1979">
                      <div className="flex items-center gap-2 mb-1" data-id="element-1980">
                        <h4 className="font-medium text-neutral-900" data-id="element-1981">
                          {policy.title}
                        </h4>
                        <Badge variant="default" className="text-xs" data-id="element-1982">
                          {policy.category}
                        </Badge>
                      </div>
                      <p className="text-sm text-neutral-600" data-id="element-1983">
                        Diajukan oleh {policy.submittedBy} • {policy.date} •
                        Versi {policy.version}
                      </p>
                    </div>
                    <Badge variant={policy.status === 'Menunggu' ? 'warning' : 'success'} data-id="element-1984">
                      {policy.status}
                    </Badge>
                  </div>
                  <div className="flex gap-2 mt-4" data-id="element-1985">
                    <Button variant="secondary" size="sm" onClick={() => handleReview(policy.id)} data-id="element-1986">
                      <Eye className="w-4 h-4 mr-2" data-id="element-1987" />
                      Review
                    </Button>
                    <Button variant="secondary" size="sm" data-id="element-1988">
                      <Download className="w-4 h-4 mr-2" data-id="element-1989" />
                      Unduh
                    </Button>
                    {policy.status === 'Menunggu' && <Button size="sm" onClick={() => handleApprove(policy.id)} data-id="element-1990">
                        <CheckCircle className="w-4 h-4 mr-2" data-id="element-1991" />
                        Setujui
                      </Button>}
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}